export default __webpack_public_path__ + "static/media/first-trainer.3bb5833f.jpg";